{"version":"26.10.27-local-solo","id":"at.softline.lagerhaus.horitschon.softline","name":"Lagerhaus Horitschon Softline"}